'use strict'

const sequence = (func, maybes) =>
  maybes.reduce(
    (acc, maybe) => acc.chain(list => maybe.map(val => list.concat(val))),
    func.of([])
  )

module.exports = sequence



// WEBPACK FOOTER //
// ../node_modules/dbsm-common/src/fp/sequence.js